import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/images/Cookies.svg'


const _withScopeId = n => (_pushScopeId("data-v-112e9d8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container_cookies"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Cookies"
}, null, -1))
const _hoisted_3 = { class: "container_cookies_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.cookies)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.getStaticCookies(0)) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.getStaticCookies(2)), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.getStaticCookies(3)), 1)
        ]),
        _createElementVNode("div", {
          class: "button_cookies",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeCookies()))
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.getStaticLanguage.cookiesOk), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}